import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Lightbulb, TrendingDown, Star, Send } from "lucide-react";
import { toast } from "sonner";

interface CustomerInsightsProps {
  data: any[];
}

export function CustomerInsights({ data }: CustomerInsightsProps) {
  const handleCampaign = (type: string) => {
    // TODO: Implement campaign actions
    toast.info("Funcionalidade em desenvolvimento");
  };

  // Identificar clientes inativos (sem compras nos últimos 90 dias)
  const inactiveCustomers = data.filter((customer) => {
    const lastTransaction = customer.transactions?.sort(
      (a: any, b: any) =>
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    )[0];

    return (
      !lastTransaction ||
      new Date(lastTransaction.created_at) <
        new Date(Date.now() - 90 * 24 * 60 * 60 * 1000)
    );
  }).length;

  // Identificar clientes VIP (top 10% em faturamento)
  const vipOpportunities = Math.floor(data.length * 0.1);

  // Identificar clientes inadimplentes
  const debtorsCount = data.filter((customer) =>
    customer.transactions?.some(
      (t: any) =>
        t.payment_status === "pendente" || t.payment_status === "atrasado"
    )
  ).length;

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2 text-[#0073B7]">
        <Lightbulb className="h-5 w-5" />
        <h3 className="text-lg font-semibold">Insights e Ações Estratégicas</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card className="p-4 space-y-4">
          <div className="flex items-center gap-2">
            <TrendingDown className="h-5 w-5 text-red-600" />
            <h4 className="font-medium">Clientes Inativos</h4>
          </div>
          <p className="text-sm text-muted-foreground">
            {inactiveCustomers} clientes não fizeram compras nos últimos 90 dias
          </p>
          <Button
            variant="outline"
            className="w-full"
            onClick={() => handleCampaign("reactivation")}
          >
            <Send className="mr-2 h-4 w-4" />
            Campanha de Reativação
          </Button>
        </Card>

        <Card className="p-4 space-y-4">
          <div className="flex items-center gap-2">
            <Star className="h-5 w-5 text-yellow-500" />
            <h4 className="font-medium">Oportunidades VIP</h4>
          </div>
          <p className="text-sm text-muted-foreground">
            {vipOpportunities} clientes com potencial para programa VIP
          </p>
          <Button
            variant="outline"
            className="w-full"
            onClick={() => handleCampaign("vip")}
          >
            <Send className="mr-2 h-4 w-4" />
            Criar Campanha VIP
          </Button>
        </Card>

        <Card className="p-4 space-y-4 md:col-span-2">
          <div className="flex items-center gap-2">
            <Lightbulb className="h-5 w-5 text-[#0073B7]" />
            <h4 className="font-medium">Ações Recomendadas</h4>
          </div>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>• Implementar programa de fidelidade para os top 10% clientes</li>
            <li>• Criar sistema de cobrança automática para {debtorsCount} inadimplentes</li>
            <li>• Desenvolver campanha de reativação para {inactiveCustomers} clientes inativos</li>
            <li>• Analisar padrões de compra para identificar oportunidades de cross-sell</li>
          </ul>
        </Card>
      </div>
    </div>
  );
}